import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import IsStadium from '../../utils/isStadium';

import { Layout, useMedia, ConditionalWrap } from '../Boneyard';
import Logo from './siteHeader/Logo';
import SkipToContent from './siteHeader/SkipToContent';

import { HEADER_LOGO } from '../../../automationHooks.json';

import { white, black } from '../../theme/theme/colors';

const propTypes = {
  theme: PropTypes.shape({
    zIndex: PropTypes.shape({
      siteHeader: PropTypes.number.isRequired,
    }),
  }),
};

const TOP_BAR_HEIGHT = 28;
const HEADER_HEIGHT_SMALL = 50;
const HEADER_HEIGHT_LARGE = 86;

const Header = styled(Layout.Header)`
  ${props => props.theme.query.lg} {
    top: 0;
    left: 0;
    right: 0;
  }
`;

const StyledNav = styled.nav`
  box-shadow: 0 1px 5px 0 ${props => props.theme.colors.siteHeader.boxShadow};
  z-index: 1;
  width: 100%;
`;

const SiteHeaderResetpassword = ({ theme }) => {
  const mq = useMedia();
  //   const [hasScrolled, setHasScrolled] = React.useState(false);

  const maxHeaderHeightLg = HEADER_HEIGHT_LARGE + TOP_BAR_HEIGHT;
  const maxHeaderHeight = HEADER_HEIGHT_SMALL;

  const headerHeightMobile = HEADER_HEIGHT_SMALL;
  //   const headerHeightDesktop = hasScrolled
  //     ? HEADER_HEIGHT_SMALL
  //     : HEADER_HEIGHT_LARGE;

  if (mq && mq.gte('md')) {
    return (
      <div
        style={{
          height: maxHeaderHeightLg,
          zIndex: theme.zIndex.siteHeader,
          background: IsStadium() ? `${black}` : `${white}`,
        }}
      >
        <SkipToContent>Skip to content</SkipToContent>

        <Header as="header">
          <StyledNav>
            <Layout.Strip>
              <Logo
                logoHeight={HEADER_HEIGHT_LARGE}
                automationHook={HEADER_LOGO.hook}
              />
            </Layout.Strip>
          </StyledNav>
        </Header>
      </div>
    );
  }

  return (
    <ConditionalWrap>
      <div
        style={{
          height: maxHeaderHeight,
          zIndex: theme.zIndex.siteHeader,
        }}
      >
        <SkipToContent>Skip to content</SkipToContent>

        <Header as="header">
          <StyledNav>
            <Layout.Strip>
              <Logo
                logoHeight={headerHeightMobile}
                automationHook={HEADER_LOGO.hook}
              />
            </Layout.Strip>
          </StyledNav>
        </Header>
      </div>
    </ConditionalWrap>
  );
};

SiteHeaderResetpassword.propTypes = propTypes;

export default withTheme(SiteHeaderResetpassword);
